/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const DropdownMenu = styled.div`
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: #fff;
  box-shadow: 0px 16px 32px 0px rgba(23, 43, 77, 0.08), 0px 16px 24px 0px rgba(23, 43, 77, 0.04);
  padding: 8px;
`;

export const BtnContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
